import Button from '@material-ui/core/Button'
import React, { Component } from 'react'
import { deviceType, isMobile, isTablet } from 'react-device-detect'
import { Link } from 'react-router-dom'
import WebFooter from '../../../source/WebScreen/WebFooter'
import '../Login.css'
import styleJson from '../../../source/styleJSON'

export class SignUpForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobileNumber: '',
      netWellUser: process.env.REACT_APP_NETWELLUSER == "true"? true :false,
      styles: process.env.REACT_APP_NETWELLUSER == "true"? styleJson.NetWell :styleJson.UHF,
    }
  }
  checkRegistration = event => {
    this.props.checkRegistration(event)
    event.preventDefault()
    console.log(event)
  }

  handleChange1 = (event, type) => {
    this.props.handleChange1(event)
  }

  toggleShow = event => {
    this.props.toggleShow(event)
  }

  handleKeyUp(e) {
    if (e.keyCode == 9) {
      e.preventDefault()
    }
  }

  render() {
    return (
      <div>
        {deviceType == 'browser' && (isMobile == false || isMobile == 'false') && (isTablet == false || isTablet == 'false') ? (
          <div class="loginformnew">
            <form onSubmit={this.checkRegistration.bind(this)}>
              <div className={this.state.styles.loginform_containernew}>
              {!this.state.netWellUser?<div class="login_image_container">
                 {null}
                </div>:
                <div className="loginform_containernetwell">
                <div class="h_left_icon_div" >
                  <img src={require('../../../source/Images/HomeIcon/netwell-logo.png')} className="netwell_logo"/>
                </div>
                  <img src={require('../../../source/Images/Banner/welcome_image_netwell.png')} className="login_main_image_netwell" />
                </div>}

                <div class="login_input_container">
                  <div  class={this.state.styles.checkregister_blue_text_container}>
                    <div class="checkregister_having_text">Having trouble logging in?</div>
                    <div class="checkregister_having_subtext">Let’s check if your email has</div>
                    <div class="checkregister_having_subtext">been registered on the portal.</div>
                  </div>

                  <div class="forgot-input-con">
                    <input
                      class="login_input_username"
                      type="email"
                      name="email"
                      pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$"
                      required
                      onChange={this.handleChange1}
                      placeholder="ENTER YOUR EMAIL"
                      onKeyDown={this.handleKeyUp}
                    />

                    <Button type="submit" class={this.state.styles.checkregister_button}>
                      CHECK REGISTRATION
                    </Button>
                  </div>
                </div>

                <div class="checkregister_goto_subtext">
                  Go back to{' '}
                  <Link to="/login">
                    <span class={this.state.styles.rege_goto}>Sign In</span>
                  </Link>
                </div>
              </div>
            </form>
            <WebFooter />
          </div>
        ) : (
          <div class="loginmobile">
            <div class="loginmobile_header_netwell">
              {/* <MenuIcon style={{ color: '#ffffff', marginRight: '20px' }} /> */}
              <div class="loginmobile_header_text_netwell">Member Portal</div>
            </div>

            
              <form onSubmit={this.checkRegistration.bind(this)}>
                <div class="loginmobile_image_container">
                  <img src={require('../../../source/Images/Banner/netwell-logo.png')} class="loginmobile_logo" />
                  <img src={require('../../../source/Images/Banner/family-looking-at-tablet_1.jpeg')} class="loginmobile_banner" />
                </div>
                <div class="loginmobile_container">
                <div class="loginmobile_input_container">
                  <input
                    type="email"
                    name="email"
                    pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$"
                    required
                    onChange={this.handleChange1}
                    placeholder="ENTER YOUR EMAIL"
                    class="loginmobile_input_username"
                  />

                  <Button type="submit" variant="contained" color="" class="loginmobile_button_netwell">
                    CHECK REGISTRATION
                  </Button>
                </div>

                <div class="loginmobile_bottom_text">
                  <div class="forgotmobile_text_details">Having trouble logging in?</div><br/>
                  <div class="forgotmobile_text_details">
                    <div>Let’s check if your email has been registered </div>
                    <div>on the portal</div>
                  </div>
                  {/* <div class="loginmobile_bottom_subtext3"></div> */}
                  <div class="loginmobile_bottom_subtext2">
                    <div>
                      Go to
                      <Link to="/login">
                        <span class="loginmobile_please_check_netwell"> Sign In</span>
                      </Link>
                    </div>
                  </div>
                </div>
                </div>
              </form>
            </div>
         
        )}
      </div>
    )
  }
}
export default SignUpForm
